import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Table,
  TableBody,
  TableRow,
  TableData
} from '../table'
import Checkbox from '../checkbox'
import {
  TableCellWidth,
  PriceByMarkupAndCurrency,
  PricePerCaratByMarkupAndCurrency,
  RapDiscountByMarkup,
  LastFiveDigitsForHash
} from '../../utils/diamond-search-result'
import * as actions from '../../actions/search'
import {
  formatDepth,
  formatTable,
  displayDashIfNotExist,
  displayDecimal
} from '../../utils/format-diamond'
import css from './style.css'
import hash from 'object-hash'
import _ from 'lodash'

export const mapStateToProps = (state, ownProps) => {
  return {
    markupType: state.settings.markupType,
    currency: state.settings.currency,
    results: state.diamondSearch.results,
    selectedItems: state.diamondSearch.selectedItems,
    colourType: state.diamondSearch.filters.colourType,
    matchedSets: state.diamondSearch.filters.matchedsets,
    highlightedRows: state.diamondSearch.highlightedRows,
    cart: state.cart.diamonds
  }
}

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onChangeCheckbox: (row) => {
      dispatch(actions.addHighlightedDiamondRow(row))
      dispatch(actions.setCompareData(row))
    },
    onClickStockNumberLink: (currentRow, currentIndex, e) => {
      if (e) e.preventDefault()
      dispatch(actions.openDetailsModal(currentRow, currentIndex))
    },
    onClickExternalLink: (currentRow, urlLink, e) => {
      if (e) e.preventDefault()
      dispatch(actions.addHighlightedDiamondRow(currentRow))
      window.open(currentRow[urlLink])
    }
  }
}

export class BodySection extends Component {
  checkForID (items, id) {
    const found = items.filter(function (el) { return el['Diamond ID'] === id })
    if (found.length) {
      return true
    } else {
      return false
    }
  }

  hasRowBeenPreviouslySelected (row) {
    return this.props.highlightedRows.indexOf(hash.sha1({'Name Code': row['Name Code'], 'Stock Number': row['Stock Number']})) > -1
  }

  isStockNumberCurrentlyInCart (row) {
    return !_.isNil(this.props.cart[row['Stock Number']])
  }

  render () {
    const props = this.props
    return (
      <Table>
        <TableBody>
          {props.results.map((row, i) => (
            <TableRow customStyle={this.isStockNumberCurrentlyInCart(row) ? css.incart : this.hasRowBeenPreviouslySelected(row) ? css.viewed : css.normal} key={i} checked={this.checkForID(props.selectedItems, row['Diamond ID']) ? 'checked' : ''}>
              <TableData width={TableCellWidth.checkbox}>
                <Checkbox checked={this.checkForID(props.selectedItems, row['Diamond ID']) ? 'checked' : ''} onChange={props.onChangeCheckbox.bind(this, row)} />
              </TableData>
              <TableData width={TableCellWidth.stockNumber}><a href='#' onClick={props.onClickStockNumberLink.bind(this, row, i)}>{row['Stock Number']}</a></TableData>
              {props.matchedSets && <TableData width={TableCellWidth.pairSort}>{LastFiveDigitsForHash(row['Pair Sort ID Hash'])}</TableData>}
              <TableData width={TableCellWidth.seller}>{row['Name Code Secret']}</TableData>
              <TableData width={TableCellWidth.shape}>{row['Shape']}</TableData>
              <TableData width={TableCellWidth.carat}>{displayDecimal(row['Weight'])}</TableData>
              <TableData width={TableCellWidth.colour}>{props.colourType === 'regular' ? row['Color'] : row['Fancy Color']}</TableData>
              <TableData width={TableCellWidth.clarity}>{displayDashIfNotExist(row['Clarity'])}</TableData>
              <TableData width={TableCellWidth.cut}>{displayDashIfNotExist(row['Cut'])}</TableData>
              <TableData width={TableCellWidth.polish}>{displayDashIfNotExist(row['Polish'])}</TableData>
              <TableData width={TableCellWidth.symmetry}>{displayDashIfNotExist(row['Symmetry'])}</TableData>
              <TableData width={TableCellWidth.fluorescence}>{displayDashIfNotExist(row['Fluorescence Intensity'])}</TableData>
              <TableData width={TableCellWidth.perCaratPrice}>${PricePerCaratByMarkupAndCurrency(props.markupType, props.currency, row)}</TableData>
              <TableData width={TableCellWidth.rapDiscount}>{RapDiscountByMarkup(props.markupType, row)}</TableData>
              <TableData width={TableCellWidth.price}>${PriceByMarkupAndCurrency(props.markupType, props.currency, row)}</TableData>
              <TableData width={TableCellWidth.lab}>{row['Certificate URL']
                ? <a href='#' onClick={(e) => props.onClickExternalLink(row, 'Certificate URL', e)}>{row['Lab'] !== 'NONE' ? row['Lab'] : 'Cert'}</a>
                : row['Lab']}
              </TableData>
              <TableData width={TableCellWidth.photo}>{row['Image URL']
                ? <a href='#' onClick={(e) => props.onClickExternalLink(row, 'Image URL', e)} className={css.photoLink} >&diams;</a>
                : <span />}
              </TableData>
              <TableData width={TableCellWidth.depth}>{formatDepth(row['Depth'])}</TableData>
              <TableData width={TableCellWidth.table}>{formatTable(row['Table'])}</TableData>
              <TableData width={TableCellWidth.measurements}>{row['Measurements']}</TableData>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }
}

BodySection.propTypes = {
  results: PropTypes.array.isRequired,
  selectedItems: PropTypes.array.isRequired,
  colourType: PropTypes.string.isRequired,
  markupType: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(BodySection)



// WEBPACK FOOTER //
// ./src/components/search-results/body-section.js